import apiClient from "../../../../../services/apiClient";

class ProfileApiService {
  // Получить профиль пользователя
  async getProfile() {
    try {
      const response = await apiClient.get('user_profile');
      return response.data;
    } catch (error) {
      console.error('Помилка отримання профілю:', error);
      throw error;
    }
  }

  // Сохранить профиль
  async saveProfile(profileData) {
    try {
      const response = await apiClient.post('user_profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Помилка збереження профілю:', error);
      throw error;
    }
  }

  // Обновить контактную информацию
  async updateContactInfo(contactInfo) {
    try {
      const response = await apiClient.put('user_profile/contact', contactInfo);
      return response.data;
    } catch (error) {
      console.error('Помилка оновлення контактів:', error);
      throw error;
    }
  }

  // Добавить пільгу
  async addBenefit(benefitData) {
    try {
      const response = await apiClient.post('user_profile/benefits', benefitData);
      return response.data;
    } catch (error) {
      console.error('Помилка додавання пільги:', error);
      throw error;
    }
  }
}

export default new ProfileApiService();